import StylingUserCalendarApi from '../StylingUserCalendarApi';
import * as types from './ActionTypes';

function getCalendarSuccess(result: any) {
    return { type: types.GET_STYLINGUSER_CALENDAR_SUCCESS, result };
}

export function getCalendar(from: any, to: any) {
    return (dispatch: (result: any) => void) =>
        StylingUserCalendarApi.getCalendar(from, to).then((result: any) => {
            dispatch(getCalendarSuccess(result));
        });
}

function updateCalendarSuccess(result: any) {
    return { type: types.UPDATE_STYLINGUSER_CALENDAR_SUCCESS, result };
}

export function updateCalendar(data: any) {
    return (dispatch: (result: any) => void) =>
        StylingUserCalendarApi.updateCalendar(data.calendar).then((result: any) => {
            dispatch(updateCalendarSuccess(result));
        });
}

function getCalendarPrintEventsSuccess(result: any) {
    return {
        type: types.GET_STYLINGUSER_CALENDAR_PRINT_EVENTS_SUCCESS,
        result
    };
}

export function getCalendarPrintEvents(from: any, to: any) {
    return (dispatch: (result: any) => void) =>
        StylingUserCalendarApi.getCalendarPrintEvents(from, to).then((result: any) => {
            dispatch(getCalendarPrintEventsSuccess(result));
        });
}

export function unbookEvent(id: number): any {
    return () => StylingUserCalendarApi.unbookEvent(id);
}

function createCalendarItemSuccess(result: any) {
    return { type: types.CREATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS, result };
}

function updateCalendarItemSuccess(result: any) {
    return { type: types.UPDATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS, result };
}

function deleteCalendarItemSuccess(result: any) {
    return { type: types.DELETE_STYLINGUSER_CALENDAR_ITEM_SUCCESS, result };
}

export function createCalendarItem(calendarItem: any) {
    let x = calendarItem;
    let item = {
        id: isNaN(Number(x.id)) ? undefined : x.id,
        orderId: x.orderId,
        title: x.title,
        description: x.description,
        type: x.type,
        start: x.start,
        end: x.end,
        userId: x.userId,
        stylingUserId: x.stylingUserId
    };

    return function (dispatch: (result: any) => void) {
        return StylingUserCalendarApi.createCalendarItem(item).then((result) => {
            result.item = item;
            dispatch(createCalendarItemSuccess(result));
        });
    };
}

export function updateCalendarItem(calendarItem: any) {
    let x = calendarItem;
    let item = {
        id: isNaN(Number(x.id)) ? undefined : x.id,
        orderId: x.orderId,
        title: x.title,
        description: x.description,
        type: x.type,
        start: x.start,
        end: x.end,
        userId: x.userId,
        stylingUserId: x.stylingUserId || x.userId
    };

    return function (dispatch: (result: any) => void) {
        return StylingUserCalendarApi.updateCalendarItem(item).then((result) => {
            dispatch(updateCalendarItemSuccess(item));
        });
    };
}

export function deleteCalendarItem(calendarItem: any) {
    return function (dispatch: (result: any) => void) {
        return StylingUserCalendarApi.deleteCalendarItem(calendarItem).then((result) => {
            dispatch(deleteCalendarItemSuccess(calendarItem));
        });
    };
}
